(async function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    let activeVariant;
    let product = JSON.parse(section.querySelector('.templateProductJSON').textContent)

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    let swiper = new Swiper(section.querySelector('.productV2VisualSwiper'), {
        navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
        }
    })
    section.querySelectorAll(`.productV2VisualThumbsThumbnail`).forEach(function (element) {
        element.addEventListener("click", function () {

            // determine index
            let index = getElIndex(this);

            // change active slide
            swiper.slideTo(index);
        });
    });

    /**
     * Build the variant options HTML
     * @param {Array} products - Array of product objects,
     * each containing variant selector information.
     */
    function constructVariantOptions(products) {
        let optionsEl = section.querySelector('.productV2FormVariant')
        optionsEl.innerHTML = '';
        let HTML = '';
        products.forEach(function (product, index) {
            let checked
            if (products.length > 1) {
                checked = index === 1 ? 'checked' : '';
            } else {
                checked = index === 0 ? 'checked' : '';
            }
            HTML += `
                <label class="productV2FormVariantLabel">
                    <input class="productV2FormVariantLabelInput" type="radio" name="${sectionID}-variant"
                           value="${product.id}" ${checked}>
                    <span class="productV2FormVariantItem">
                         <span class="productV2FormVariantItemTag">${product.variant_selector.label}</span>
                         <span class="productV2FormVariantItemTag mobile">${product.variant_selector.mobile_label}</span>
                         <span class="productV2FormVariantItemTitle">${product.variant_selector.title}</span>
                         <span class="productV2FormVariantItemInterval">${product.variant_selector.shipping_interval}</span>
                         <span class="productV2FormVariantItemUnitPrice">${product.variant_selector.per_price}</span>
                    </span>
                </label>
            `;
        });
        // set HTML
        optionsEl.innerHTML = HTML;
    }

    // initialize the variant options with the subscription products
    constructVariantOptions(subscriptionProducts);

    // update product on variant change
    section.querySelectorAll('.productV2FormVariantLabelInput').forEach(function (input) {
        input.addEventListener('change', function () {
            updateProduct();
        });
    })

    // update variant options on plan change
    section.querySelectorAll('.productV2FormPlanLabelInput').forEach(function (input) {
        input.addEventListener('change', function () {
            // update product
            updateProduct();
        });
    })


    function isSubscription() {
        return section.querySelector('.productV2FormPlanLabelInput:checked')?.value === 'sub';
    }

    /**************
     Update Product
     ***************/

    async function updateProduct() {

        // rebuild the variant options based on the selected plan
        let products = isSubscription() ? subscriptionProducts : oneTimeProducts;
        section.querySelectorAll('.productV2FormVariantLabel').forEach(function (element, index) {
            let product = products[index];

            // update element
            element.querySelector('.productV2FormVariantLabelInput').value = product.id;
            element.querySelector('.productV2FormVariantItemTag').textContent = product.variant_selector.label;
            element.querySelector('.productV2FormVariantItemTag.mobile').textContent = product.variant_selector.mobile_label;
            element.querySelector('.productV2FormVariantItemTitle').textContent = product.variant_selector.title;
            element.querySelector('.productV2FormVariantItemInterval').textContent = product.variant_selector.shipping_interval;
            element.querySelector('.productV2FormVariantItemUnitPrice').textContent = product.variant_selector.per_price;
        })

        // if it's one time, hide shipping interval
        section.querySelectorAll('.productV2FormVariantItemInterval').forEach(function (el) {
            if (!isSubscription()) {
                el.classList.remove('active');
            } else {
                el.classList.add('active');
            }
        });

        // find possible products
        let possibleProducts = isSubscription() ? subscriptionProducts : oneTimeProducts;


        if (!section.querySelector('.productV2FormVariantLabelInput')) {

            section.querySelector('.productV2FormATC').textContent = "Unavailable"
            section.querySelector('.productV2FormATC').disabled = true;
            section.querySelector('.productV2StickyBodyRightATCTxt').textContent = "Unavailable"
            section.querySelector('.productV2StickyBodyRightATC').disabled = true;
            return;
        }

        // find the selected product
        let selectedProductId = parseInt(section.querySelector('.productV2FormVariantLabelInput:checked').value);


        // find the active variant
        activeVariant = possibleProducts.find(product => product.id === selectedProductId);

        // find the one time version of the active variant
        let skuPrefix = activeVariant.sku.split('-')[0]; // LIV1153-3X or LIV1153-3S
        let skuType = activeVariant.sku.split('-')[1]; // 3S

        // pack size is the first letter of SKU (3)
        let packSize = skuType.replace(/[SsXx]/g, ''); // remove S or X
        let oneTimeSku = `${skuPrefix}-${packSize}X`;
        let subSku = `${skuPrefix}-${packSize}S`;

        let oneTimeVariant = oneTimeProducts.find(product => product.sku === oneTimeSku);
        let subVariant = subscriptionProducts.find(product => product.sku === subSku);

        // update price display
        section.querySelector('.productV2FormPlanLabelBodyActual.sub').textContent = price(subVariant.price, true);
        section.querySelector('.productV2FormPlanLabelBodyActual.once').textContent = price(oneTimeVariant.price, true);

        // check for compare price (mirror v5: strike-through only when compare > price)
        section.querySelector('.productV2FormPlanLabelBodyCompare.sub').textContent = '';
        if (subVariant.compare_at_price > subVariant.price) {
            section.querySelector('.productV2FormPlanLabelBodyCompare.sub').textContent = price(subVariant.compare_at_price, true);
        }
        section.querySelector('.productV2FormPlanLabelBodyCompare.once').textContent = '';
        if (oneTimeVariant.compare_at_price > oneTimeVariant.price) {
            section.querySelector('.productV2FormPlanLabelBodyCompare.once').textContent = price(oneTimeVariant.compare_at_price, true);
        }

        // update active image
        if (activeVariant.featured_image) {
            // change active slide
            section.querySelector('.productV2VisualSwiperImage').src = activeVariant.featured_image;
            section.querySelector('.productV2StickyBodyLeftImg').src = activeVariant.featured_image;
        }

        // update Subscription selector save amount
        section.querySelector('.productV2FormPlanLabelBodyListItem').textContent = " Subscribe & save " + subVariant.savings;

        if (Shopify.theme.role === "development") {
            window.activeVariant = activeVariant;
        }

        // available
        if (activeVariant.available) {
            section.querySelector('.productV2FormATC').textContent = "ADD TO CART"
            section.querySelector('.productV2FormATC').disabled = false;
            section.querySelector('.productV2StickyBodyRightATCTxt').textContent = "ADD TO CART"
            section.querySelector('.productV2StickyBodyRightATC').disabled = false;
        } else {
            section.querySelector('.productV2FormATC').textContent = "SOLD OUT"
            section.querySelector('.productV2FormATC').disabled = true;
            section.querySelector('.productV2StickyBodyRightATCTxt').textContent = "SOLD OUT"
            section.querySelector('.productV2StickyBodyRightATC').disabled = true;
        }

        // Update sticky ATC
        section.querySelector(".productV2StickyBodyRightOptionAmount").textContent = activeVariant.variant_selector.title;
        section.querySelector(".productV2StickyBodyLeftMobileAmount").textContent = activeVariant.variant_selector.title;
        section.querySelector(".productV2StickyBodyRightOptionInterval").textContent = activeVariant.variant_selector.shipping_interval ?? "";
        section.querySelector(".productV2StickyBodyLeftMobileInterval").textContent = activeVariant.variant_selector.shipping_interval ?? "";
        section.querySelector(".productV2StickyBodyRightATCCompare").textContent = activeVariant.compare_at_price ? price(activeVariant.compare_at_price) : "";
        section.querySelector(".productV2StickyBodyRightATCPrice").textContent = price(activeVariant.price);


        // B2B Selling plan
        let sellingPlanSelect = section.querySelector('.productV2FormPlanSelect') || false;
        if (sellingPlanSelect) {
            // add in selling plans
            let HTML = '';
            subVariant.selling_plans.forEach(function (plan) {
                HTML += `
                    <option value="${plan.id}">${plan.name}</option>
                `;
            });
            sellingPlanSelect.innerHTML = HTML;
        }

    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();


    /**************
     Product ATC
     ***************/
    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV2FormATC").classList.add("loading");

        let sellingPlan = activeVariant.plan_id || null

        // B2B Selling plan select override
        let sellingPlanSelect = section.querySelector('.productV2FormPlanSelect') || false;
        if (sellingPlanSelect && isSubscription()) {
            sellingPlan = parseInt(sellingPlanSelect.value);
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.variant_id,
                selling_plan: sellingPlan
            }]
        };


        // check for add on
        section.querySelectorAll('.productV3AddOnItemBodySwitchInput:checked')?.forEach(function (element) {
            formData.items.push({
                quantity: 1,
                id: element.dataset.id,
                selling_plan: element.dataset.selling || null
            });
        })


        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV2FormATC").classList.remove("loading");

        // open cart
        await openCart();

        // record GA4 & Klaviyo tracking
        await tracking(formData);
    }

    section.querySelector('.productV2FormATC').addEventListener("click", addToCart);

    // the ATC button is wrapped in a form for valid markup, but the cart add is handled in JS ‚Äî block the native submit
    section.querySelector('.productV2FormATCWrapper').addEventListener("submit", function (e) {
        e.preventDefault();
    });

    // Reviews scroll
    section.querySelector('.productV2DropsItemBodyReviews').addEventListener("click", function () {
        // scroll to section of page with reviewsTarget (reviewsTarget is created in the FAQ section, based on section.id)
        window.scroll({
            top: document.querySelector(`#${reviewsTarget}`).offsetTop - 100,
            behavior: "smooth"
        })
    })

    /**************
     STICKY ATC
     ***************/
    section.querySelectorAll('.productV2StickyBodyRightATC').forEach(function (el) {
        el.addEventListener('click', function () {
            // add loading animation
            this.classList.add('loading');

            addToCart();

            // wait 1 second
            setTimeout(function () {
                // remove loading animation
                el.classList.remove('loading');
            }, 1000);
        });
    });

    // the sticky ATC button is wrapped in a form for valid markup, but the cart add is handled in JS ‚Äî block the native submit
    section.querySelectorAll('.productV2StickyBodyRightATCWrapper').forEach(function (form) {
        form.addEventListener("submit", function (e) {
            e.preventDefault();
        });
    });

    /************
     Dynamic Sold Out
     ************/
    (function () {
        // Get the current date and time
        let currentDate = new Date();
        // let currentDate = new Date("2024-05-29T23:59:00");

        // The date everything is relative to - which is a Sunday.
        let targetDate = new Date("2024-04-28T23:59:00");

        // Increment the counter for every day that has passed
        let daysPassed = Math.floor((currentDate - targetDate) / (1000 * 60 * 60 * 24) % 7);

        // get the next monday from current date
        let nextMonday = new Date(currentDate);
        nextMonday.setDate(currentDate.getDate() + 8 - currentDate.getDay());

        // get the last monday from current date
        let lastMonday = new Date(currentDate);
        lastMonday.setDate(currentDate.getDate() + 1 - currentDate.getDay());

        // Update the text with the incremented number
        section.querySelectorAll(".percentSold")?.forEach(function (element) {
            element.textContent = daysPassed + 91;
        });

        // Update the date with the next monday
        section.querySelectorAll(".preOrderDate")?.forEach(function (element) {
            element.textContent = nextMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });

        // Update the date with the last Monday
        section.querySelectorAll(".lastOrderDate")?.forEach(function (element) {
            element.textContent = lastMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });
    })();


    // dropdown event listeners for each of the titles
    section.querySelectorAll(`.productV2DropsItemTitle`).forEach(function (element) {
        element.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
        });
    });

    // random number gen (23-100) for checking out now text
    section.querySelectorAll(".productV2CheckingOutNum").forEach(function (element) {
        element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
    });
    // Do it every 3 seconds
    setInterval(function () {
        section.querySelectorAll(".productV2CheckingOutNum").forEach(function (element) {
            element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
        });
    }, 3000);


    /**************
     Product Add On
     ***************/
        // swiper
    let hasAddOns = section.querySelector('.productV3AddOn') || false;
    if (hasAddOns) {
        let addOnSwiper = new Swiper(section.querySelector('.productV3AddOn'), {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
                el: section.querySelector('.productV3AddOnPag'),
                clickable: true,
            },
            breakpoints: {},
        });
    }


    /************
     GA4 & Klaviyo Tracking
     ************/
    async function tracking(formData) {

        // GA4 add_to_cart
        const sourceProduct = activeVariant.product;
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: Shopify.currency.active,
                value: sourceProduct.variants[0].price * quantity / 100,
                items: [{
                    item_id: sourceProduct.id,
                    item_name: sourceProduct.title,
                    item_category: sourceProduct.type,
                    item_variant: sourceProduct.variants[0].title,
                    price: sourceProduct.variants[0].price / 100,
                    quantity: quantity,
                    subscription_item: !!formData.selling_plan,
                }],
                subscription_included: !!formData.selling_plan,
            }
        });

        // push to klavviyo
        try {
            _learnq.push(["track", "Added to Cart", {
                "$value": sourceProduct.price * quantity / 100,
                "AddedItemProductName": sourceProduct.title,
                "AddedItemProductID": sourceProduct.id,
                "AddedItemSKU": sourceProduct.variants[0].sku,
                "AddedItemCategories": sourceProduct.tags,
                "AddedItemImageURL": sourceProduct.featured_image?.src,
                "AddedItemURL": `https://getlivfresh.com/products/${product.handle}`,
                "AddedItemPrice": sourceProduct.price,
                "AddedItemQuantity": 1,
                "ItemNames": [sourceProduct.title],
                "CheckoutURL": "https://livfresh.com/checkout",
                "Items": [{
                    "ProductID": sourceProduct.id,
                    "SKU": sourceProduct.variants[0].sku,
                    "ProductName": sourceProduct.title,
                    "Quantity": quantity,
                    "ItemPrice": sourceProduct.price / 100,
                    "RowTotal": sourceProduct.price * quantity / 100,
                    "ProductURL": `https://getlivfresh.com/products/${product.handle}`,
                    "ImageURL": sourceProduct.featured_image?.src,
                    "ProductCategories": sourceProduct.tags
                }]
            }]);
        } catch (e) {
            console.log(e)
        }
    }


}());